"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const trustees = [{
  name: "Mr. Alasdair James Farquhar Fisher",
  role: "CHAIR & FOUNDER",
  bio: "Alasdair established the foundation to provide equitable educational opportunities for children in Ghana. His strategic vision guides our UK operations and international partnerships.",
  image: "https://touching-owl.10web.cloud/wp-content/uploads/2026/03/Oga.jpeg?v=tikmt1hrzj",
  linkedin: "#"
}, {
  name: "Mrs Adelaide Fisher",
  role: "TRUSTEE",
  bio: "With deep roots in local community development, Emmanuel oversees our projects on the ground. He ensures our scholarships and resources reach the most disadvantaged students effectively.",
  image: "https://farquharfisherfoundation.co.uk/wp-content/uploads/2026/03/67-1.jpeg?v=j2hzpwm84l",
  linkedin: "#"
}, {
  name: "Ms. Esther Amofa-Afriyie",
  role: "TRUSTEE",
  bio: "David ensures our financial transparency and compliance as a UK-registered charity. He manages our donor funds with precision, ensuring maximum impact for every pound donated.",
  image: "https://farquharfisherfoundation.co.uk/wp-content/uploads/2026/03/Esther-Amofa-Afriyie-Copy-1.jpeg?v=squol79cmqp",
  linkedin: "#"
}, {
  name: "Ms. Esther Mensah",
  role: "TRUSTEE",
  bio: "Sarah provides strategic guidance on educational standards and teacher development, leveraging her extensive background in academic leadership to enhance our impact in Ghana.",
  image: "https://farquharfisherfoundation.co.uk/wp-content/uploads/2026/03/Esther-Mensah-1.jpeg?v=482g36tkst2",
  linkedin: "#"
}];
export default function TheTrusteeBoard() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="128266" id="leadership-and-trustees" className="bg-background text-foreground ![padding:40px_0px_96px_0px]">
      <div className="container mx-auto px-4 sm:px-6">
        <div ref={headerRef} className={`mx-auto mb-10 max-w-3xl text-center transition-all duration-700 ease-out sm:mb-12 lg:mb-16 ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="mb-4 font-sans text-3xl font-bold tracking-tight text-primary sm:mb-6 sm:text-4xl md:text-5xl">
            Our Leadership & Trustees
          </h2>
          <p className="font-sans text-base leading-7 text-muted-foreground sm:text-lg sm:leading-relaxed">
            Meet the dedicated team overseeing our mission to transform lives
            through education in Ghana. Our board ensures every initiative is
            rooted in transparency and local impact.
          </p>
        </div>

        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {trustees.map((trustee, i) => <TrusteeCard key={trustee.name} trustee={trustee} index={i} />)}
        </div>
      </div>
    </section>;
}
function TrusteeCard({
  trustee,
  index
}: {
  trustee: (typeof trustees)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const delay = index * 150;
  return <div data-index={index} ref={ref} className="h-full transition-all duration-700 ease-out" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(30px)",
    transitionDelay: `${delay}ms`
  }}>
      <Card className="flex h-full flex-col items-center rounded-2xl border-border/60 bg-card px-5 py-8 text-center shadow-md transition-all duration-300 hover:shadow-xl sm:px-6 sm:py-10 lg:px-5">
        <SafeHydrate><Avatar className="mb-5 size-24 border-4 border-secondary shadow-sm sm:size-28 lg:size-24 xl:size-28">
          <AvatarImage src={trustee.image} alt={`Headshot of ${trustee.name}`} className="object-cover" />
          <AvatarFallback className="bg-accent font-sans text-2xl font-bold text-primary sm:text-3xl">
            {trustee.name.split(" ").map(n => n[0]).join("")}
          </AvatarFallback>
        </Avatar></SafeHydrate>

        <h3 className="mb-2 font-sans text-lg font-bold leading-snug text-primary sm:text-xl lg:text-lg xl:text-xl">
          {trustee.name}
        </h3>

        <p className="font-mono text-[11px] font-bold uppercase tracking-widest text-secondary sm:text-xs">
          {trustee.role}
        </p>
      </Card>
    </div>;
}